<template>
  <div class="jytp-con">
    <div class="classSelect">
      <div class="transversely" v-if="!classmore">
        <div class="search">
          <van-field v-model="searchTitle" placeholder="请输入股票、资讯关键词" @input="inputSearch" clearable />

          <img src="../assets/images/search.png" alt="" @click="handleClickSelImg" v-if="themeStyleVs == 1" />
          <img src="../assets/images/black/search.png" alt="" @click="handleClickSelImg" v-else />
        </div>

        <div class="moreBtn" @click="unfold()">产业筛选</div>
      </div>
      <div v-else class="select_pop_bg">
        <div class="select_pop">
          <div class="sortTitle" style="padding: 0.1rem 0.16rem 0">产业筛选</div>
          <div class="classifyList">
            <div class="item" v-for="(item, index) in classList" :key="index" @click="unfoldSelect(index, item)" :class="tuClassIndex == index + 1 ? 'select' : ''">
              <img src="../assets/images/hot.png" alt="" v-if="item.hotType == 1" />
              {{ item.name }}
            </div>
            <div style="width: 100%">
              <div class="sortTitle" style="margin-bottom: 0.1rem">排序</div>
              <div style="display: flex">
                <div class="item" :class="OrderBy[0] == '-Pubdate' ? 'select' : ''" @click="handleClickTime">按时间</div>
                <div class="item" :class="OrderBy[0] == '-Increase' ? 'select' : ''" @click="handleClickZf">按涨跌</div>
              </div>
            </div>
            <div class="classBtn">
              <div class="reset" @click="handleClickReset">重置</div>
              <div class="confirm" @click="hendleClickConfirm">确定</div>
            </div>
          </div>

          <div class="close">
            <van-icon name="cross" @click="classmore = false" />
          </div>
        </div>
      </div>
    </div>

    <!-- maxCols: 瀑布显示最大列数 -->
    <!-- gap: 图片之间的空间（px） -->
    <!-- maxCols: 用于渲染瀑布流的数据
                  每个数组元素都是一个对象，必须具有src和href属性。
                  src属性表示图片的src属性
                  href属性表示要单击以跳转的链接
                  -->

    <!-- 视图样式1 -->
    <div v-if="viewStatus">
      <vue-waterfall-easy ref="waterfall" v-if="!industryNull" style="height: calc(100vh - 1.27rem)" :width="maxWidth" :imgsArr="imgsArr" :gap="24" :maxCols="20" @click="clickFn" :linkRange="'custom'" :reachBottomDistance="20" @scrollReachBottom="getSearch" :loadingTimeOut="300" :key="waterfallKey">
        <div slot="loading" class="loading" v-if="isFirstLoad">
          <van-loading color="" type="spinner"></van-loading>
        </div>

        <div slot-scope="props" class="tu-item-show">
          <div class="video-box" @click.stop="gotoVideo(props.value.item.Related.VideoUrl)" v-show="props.value.item.Related.VideoUrl != '' && props.value.item.Related.VideoUrl != undefined">
            <img src="../assets/images/video-btn.png" alt="" />
            <div>查看视频解说</div>
          </div>

          <div class="title">{{ props.value.item.Title }}</div>

          <div style="display: flex; justify-content: space-between">
            <div v-show="props.value.item.Concepts != undefined && props.value.item.Concepts.length > 0" class="stock" :class="[judgeColor(Number(props.value.item.Increase))]">
              {{ props.value.item.ZhongWenJianCheng }}
              {{ props.value.item.Increase == undefined || props.value.item.Increase == "" ? "--" : props.value.item.Increase + "%" }}
            </div>
            <div class="time">{{ props.value.item.Pubdate.slice(0, 10) }}</div>
          </div>

          <div class="pdf-btn" v-show="props.value.item.Related.ArticleUrl != undefined && props.value.item.Related.ArticleUrl != '' && props.value.item.Related.ArticleUrl != null" @click.stop="gotoPdf(props.value.item.Related.ArticleUrl)">
            <img style="width: 0.16rem; height: 0.16rem" src="../assets/images/pdf.png" />
            <div style="font-size: 0.11rem; margin-left: 0.04rem">
              {{ props.value.item.Title }}
            </div>
          </div>

          <img class="hot-icon" src="../assets/images/vector-hot-bg.png" alt="" v-show="props.value.item.Extra.tag == 'hot'" />
        </div>

        <div slot="waterfall-over" class="waterfall-over" style="display: none">已加载全部</div>
      </vue-waterfall-easy>
    </div>

    <!-- 视图样式2 -->

    <ul v-else class="tpNewList">
      <van-list v-model="loading" :finished="finished" finished-text="已加载全部" @load="getSearch">
        <li v-for="(item, index) in imgsArr" :key="item.Id">
          <span class="circle1" v-if="index == 0"></span>
          <span class="circle2" v-else></span>
          <div class="top">
            <div class="left">
              <span class="title">{{ item.item.Title }}</span>
              <span :class="[judgeColor(Number(item.item.Increase))]">
                {{ item.item.Increase == undefined || item.item.Increase == "" ? "--" : item.item.Increase + "%" }}
              </span>
            </div>

            <div class="right">
              5分钟涨幅
              <span :class="[judgeColor(Number(item.item.IncreasePer5Minutes))]">
                {{ item.item.IncreasePer5Minutes == undefined || item.item.IncreasePer5Minutes == "" ? "--" : item.item.IncreasePer5Minutes + "%" }}
              </span>
            </div>
          </div>

          <div class="cover" :style="`background:url('${item.src}')no-repeat center 2%; background-size: cover;`" @click="toDetail(item)"></div>

          <div class="correlation">
            <span class="label">相关股票</span>

            <span class="stokList">
              <i>主板</i>
              {{ countStockCategories(item.item.Stocks).zhuban }}只
            </span>
            <span class="stokList" v-if="countStockCategories(item.item.Stocks).chuangyeban">
              <i>创业板</i>
              {{ countStockCategories(item.item.Stocks).chuangyeban }}只
            </span>
            <span class="stokList" v-if="countStockCategories(item.item.Stocks).kechuangban">
              <i>科创板</i>
              {{ countStockCategories(item.item.Stocks).kechuangban }}只
            </span>
          </div>

          <div class="study" v-if="item.item.Related.ArticleUrl || item.item.Related.VideoUrl">
            <span class="label">深度研究</span>
            <span class="link" @click="gotoPdf(item.item.Related.ArticleUrl)" v-if="item.item.Related.ArticleUrl">pdf报告&gt;</span>
            <span class="link" @click="gotoVideo(item.item.Related.VideoUrl)" v-if="item.item.Related.VideoUrl">视频解说&gt;</span>
          </div>
        </li>
      </van-list>
    </ul>

    <div v-if="industryNull && industryNullMsg == '暂无数据'" class="no-result">
      <img src="../assets/images/blank.png" alt="" />
      <p>{{ industryNullMsg }}</p>
    </div>
  </div>
</template>

<script>
  import vueWaterfallEasy from "vue-waterfall-easy";

  export default {
    props: ["themeStyleVs", "handleDataLoadedNum", "viewStatus"],
    data() {
      let maxWidth = window.innerWidth;
      if (maxWidth > 792) maxWidth = 792;
      return {
        maxWidth,
        waterfallKey: 0,
        searchTitle: "", //搜索文字
        isFirstLoad: true,
        sortIndex: 1,
        unfoldIndex: 0,
        classmore: false,
        tuClassIndex: 0,
        classList: [],
        tualllist: [],
        token: "",
        industryNull: true,
        industryNullMsg: "加载中",
        imgsArr: [],
        YunToken: "",
        isMore: false,
        loading: false,
        finished: false,
        Start: 0,
        OrderBy: ["-Increase"],
        Summary: "",
        Catalog: "",
        isComposing: false, // 用于标记是否处于拼音输入组合阶段
      };
    },
    watch: {
      viewStatus(i) {
        this.tuClassIndex = 0;
        this.Catalog = "";
        this.Start = 0;
        this.imgsArr = [];
        this.viewStatus = i;
        this.searchTitle = "";

        if (!i) {
          this.loading = true;
          this.finished = false;
        }

        this.getSearch();
      },
    },
    components: {
      vueWaterfallEasy,
    },
    created() {},
    async mounted() {
      this.token = this.$route.query.token;
      await this.getYunToken();
      await this.getCylTpClass();
      await this.getSearch();
    },

    methods: {
      judgeColor(n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },
      //!!!!!!注意  这也页面用到的云平台token走这个接口生成  其他用到的还是走之前的js自己生成 因为目前只发现这里用自己生成的token会报错token过期
      //获取云平台token
      async getYunToken() {
        try {
          let res = await this.$http({
            method: "get",
            url: window.config.api_v3 + "/token/access",
            params: {
              appid: window.config.appid,
              secret_key: window.config.secretKey,
            },
          });
          this.YunToken = res.data.Data.RepDataToken[0].token;
        } catch (error) {
          console.error(error);
        }
      },
      //判断url的参数
      appendVersionParameter(url) {
        if (url.includes("?")) {
          return url + "&v=" + Date.now();
        } else {
          return url + "?v=" + Date.now();
        }
      },
      clickFn(event, { index, value }) {
        let _this = this;
        if (event.target.className == "video-box") {
          _this.gotoVideo(value.item.playbackUrl);
        } else if (event.target.className == "pdf-btn" || event.target.className == "title") {
          var matches = value.item.Related.ArticleUrl.match(/^.*\/([^/?#]*)$/);
          _this.dzhDownload(value.item.Related.ArticleUrl, matches[1]);
        } else {
          // _this.gotoDetailPage(value.item.SourceId,value.item);
          this.toUrl(value.item.Mapping ? _this.appendVersionParameter(value.item.Mapping) : _this.appendVersionParameter(value.item.DataResource) + "&DZHSPECIAL=257")
        }

        // 阻止a标签跳转
        event.preventDefault();
        // 只有当点击到图片时才进行操作
        if (event.target.tagName.toLowerCase() == "img") {
          console.log("img clicked", index, value);
        }
      },

      gotoPdf: function (pdfurl) {
        var link = document.createElement("a");
        link.href = pdfurl;
        const lastSlashIndex = pdfurl.lastIndexOf("/");

        link.download = pdfurl.substring(lastSlashIndex + 1);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      handleClickTime() {
        this.$set(this.OrderBy, 0, "-Pubdate");
      },

      handleClickZf() {
        this.$set(this.OrderBy, 0, "-Increase");
      },

      unfoldSelect: function (index, item) {
        this.tuClassIndex = index + 1;
        this.Catalog = item.name;
      },

      unfold: function () {
        this.classmore = true;
      },
      gotoVideo: function (url) {
        if (url.includes("?")) {
          url += "&DZHSPECIAL=1";
        } else {
          url += "?DZHSPECIAL=1";
        }
        this.toUrl(url)
      },
      gotoDetailPage: function (id, item) {
        var logo = "http://static.yundzh.com/logo.png";
        var hrefString = "dzh_browser_url&goto=0&screen=143";

        hrefString += "&title=【全链研究】" + item.title + "&text=产业图谱";
        hrefString += "&url=" + encodeURIComponent(window.location.origin + "/h5_qlyj_new/cyltpDetail?DZHSPECIAL=1048577&id=" + id);
        hrefString += "&icon=" + logo;
        hrefString += "&kind=55";

        var shareUrl = this.$base64.encode(hrefString);
        var url = "cyltpDetail?DZHSPECIAL=1048577&id=" + id + "&share_url=" + shareUrl;
        this.toUrl(url)
      },
      //获取产业链图谱 分类
      async getCylTpClass() {
        try {
          let response = await this.$http({
            method: "get",
            url: window.config.baiduBucket + "/wap/data/news-web/qlyj/graphCateList.json",
          });
          this.classList = response.data.data;
        } catch (error) {
          console.error(error);
        }
      },

      // title为空
      inputSearch() {
        // 如果处于拼音输入组合阶段，直接返回，不执行搜索
        if (this.isComposing) {
          return;
        }

        if (this.searchTitle === "") {
          this.handleClickReset();
        }
      },

      handleCompositionEnd() {
        // 当拼音输入结束时，将标记设为 false，并执行输入事件
        this.isComposing = false;
        this.inputSearch();
      },

      //点击筛选确认按钮
      hendleClickConfirm() {
        this.searchTitle = "";
        this.classmore = false;
        this.imgsArr = [];
        this.waterfallKey++;

        this.Start = 0;

        this.getSearch();
      },

      //点击重置按钮
      handleClickReset() {
        this.tuClassIndex = 0;
        this.Catalog = "";
        this.classmore = false;
        this.imgsArr = [];
        this.searchTitle = "";
        this.Summary = "";
        this.Start = 0;
        this.$set(this.OrderBy, 0, "-Increase");
        this.getSearch();
      },

      //点击图片放大镜
      handleClickSelImg() {
        this.tuClassIndex = 0;
        this.Catalog = "";
        this.classmore = false;
        this.imgsArr = [];
        this.Summary = "";
        this.Start = 0;
        this.$set(this.OrderBy, 0, "-Increase");
        this.getSearch();
      },

      // 获取图谱列表数据   接口获取  博士
      getSearch: function () {
        var _this = this;

        _this.industryNullMsg = "加载中";

        this.$http({
          method: "post",
          url: window.config.charts + "/charts/common/search",
          data: {
            Qid: new Date(),
            Request: {
              Category: "产业图谱",
              Size: 10,
              Start: _this.Start, // 使用 start 参数来分页请求
              Title: _this.searchTitle, //标题搜索词
              Summary: _this.Summary, //摘要搜索词
              OrderBy: _this.OrderBy,
              Catalog: _this.Catalog, //行业中文名称
            },
          },
        }).then(async function (response) {
          // 加载状态结束
          _this.loading = false;
          if (response.data.ErrCode == 0 && response.data.Response.Charts.length) {
            _this.industryNull = false;
            _this.tualllist = response.data.Response.Charts;

            const newImages = _this.tualllist.map((element) => ({
              src: element.DataResource + "@q_75",
              href: element.DataResource,
              item: element,
            }));
            _this.imgsArr = _this.imgsArr.concat(newImages);

            // 检查是否还有数据可以加载
            if (_this.tualllist.length >= 10) {
              _this.Start += 10;
            } else {
              if (_this.$refs.waterfall) {
                _this.$toast({
                  message: "已加载全部",
                  position: "bottom",
                });
                _this.$refs.waterfall.waterfallOver(); //当滚动加载数据结束时，手动调用，将会取消滚动加载
              } else {
                _this.finished = true;
              }
            }

            if (_this.handleDataLoadedNum == 2) {
              _this.$emit("data-loaded"); // 发出事件通知父组件数据已经加载完毕
            }
          } else {
            _this.finished = true;
            _this.industryNullMsg = "暂无数据";
            _this.industryNull = true;
          }
        });
      },

      toDetail(item) {
        this.toUrl(item.item.Mapping);
      },

      countStockCategories(stocks) {
        let zhubanCount = 0; // 统计主板（SZ0开头）的数量
        let chuangyebanCount = 0; // 统计创业板（SZ3开头）的数量
        let kechuangbanCount = 0; // 统计科创板（SH688开头）的数量

        stocks.forEach((stock) => {
          if (stock.startsWith("SH60") || stock.startsWith("SZ0")) {
            zhubanCount++; // 如果是主板股票，数量加1
          } else if (stock.startsWith("SZ3")) {
            chuangyebanCount++; // 如果是创业板股票，数量加1
          } else if (stock.startsWith("SH688")) {
            kechuangbanCount++; // 如果是科创板股票，数量加1
          }
        });

        return {
          zhuban: zhubanCount, // 返回主板股票的数量
          chuangyeban: chuangyebanCount, // 返回创业板股票的数量
          kechuangban: kechuangbanCount, // 返回科创板股票的数量
        };
      },
    },
  };
</script>
<style>
  .alink .img-wraper {
    border-radius: 12px;
    max-height: 520px;
    overflow: hidden;
  }
  .vue-waterfall-easy-container > .loading {
    z-index: 1 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .waterfall-over {
    padding: 10px 0 20px;
  }
</style>
<style lang="scss" scoped>
  .jytp-con {
    .search {
      background: #f6f6f6;
      border-radius: 0.2rem;
      width: 1.98rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.12rem;
      flex: none;
      ::v-deep {
        .van-field__control {
          color: #e4e9fe;
        }
      }
      &.win100 {
        width: 100%;
      }
      .van-cell {
        background: unset;
        height: 0.25rem;
        color: #222;
        font-size: 0.12rem;
        padding: 0;
        margin-right: 0.12rem;
        &::placeholder {
          font-size: 0.12rem;
          color: #999;
        }
        &:after {
          display: none;
        }
      }
      img {
        width: 0.13rem;
        flex: none;
      }
    }
    .sortTitle {
      font-size: 0.14rem;
      color: #222222;
    }
    .tu-item-show {
      .title {
        margin: 0.08rem 0.08rem;
        color: #555;
        // color: #E4E9FE;

        font-family: PingFang SC;
        font-size: 0.14rem;
        font-style: normal;
        font-weight: 400;

        white-space: nowrap; /* 防止文字换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
      }
      .time {
        margin-bottom: 0.08rem;
        margin-left: 0.08rem;
        color: #999;
        font-family: PingFang SC;
        font-size: 0.12rem;
        font-style: normal;
        font-weight: 400;
      }

      .stock {
        margin-left: 0.08rem;
        font-family: PingFang SC;
        font-size: 0.12rem;
        font-style: normal;
        font-weight: 400;
        color: #999;
      }

      .pdf-btn {
        margin: 0.08rem;
        background: #f5f6fa;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.085rem;
      }

      .hot-icon {
        width: 0.51rem;
        position: absolute;
        top: 4px;
        left: 4px;
      }

      .video-box {
        width: 1rem;
        white-space: nowrap; /* 防止文字换行 */
        border-radius: 0.32rem;
        background: rgba(40, 109, 247, 0.9);
        position: relative;
        top: -0.3rem;
        left: 50%;
        transform: translate(-50%, -10%);
        padding: 0.04rem 0.08rem;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFang SC;
        font-size: 0.11rem;
        font-style: normal;
        font-weight: 400;
        img {
          width: 0.12rem;
          display: block;
          margin-right: 0.04rem;
        }
      }
    }

    .classSelect {
      padding: 5px 0;

      .transversely {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.12rem;
        padding: 0.03rem 0.34rem 0.03rem 0.16rem;
        .moreBtn {
          color: #555;
          display: flex;
          align-items: center;
          position: relative;
          &:after {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            border-top: 1px solid #999;
            border-right: 1px solid #999;
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
            position: absolute;
            right: -0.12rem;
            top: 0.04rem;
          }
        }
      }
      .classifyList {
        display: flex;
        flex-wrap: wrap;
        color: #555;
        padding: 0.12rem 0.16rem;
        .item {
          border: 1px solid #f5f6f9;
          text-align: center;
          padding: 0.08rem 0.17rem;
          border-radius: 0.06rem;
          margin-right: 0.1rem;
          margin-bottom: 0.1rem;
          font-size: 0.12rem;
          img {
            width: 0.1rem;
            height: 0.13rem;
          }
        }
        .item.select {
          color: #3b85fe;
          text-align: center;
          font-family: PingFang SC;
        }
        .classBtn {
          margin-top: 0.16rem;
          width: 100%;
          display: flex;
          .reset {
            color: #000;

            text-align: center;
            width: 34%;
            border-radius: 0.32rem;
            background: #f8f8f8;
            margin-right: 0.1rem;
            padding: 0.11rem 0.41rem;
          }
          .confirm {
            color: #fff;

            text-align: center;
            width: 65%;
            border-radius: 0.32rem;
            background: #3b85fe;
            padding: 0.11rem 0.41rem;
          }
        }
      }
    }

    .select_pop_bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 10;
      background: rgba(0, 0, 0, 0.8);
      height: 100vh;
      .select_pop {
        background: #fff;
        position: relative;
        .close {
          position: absolute;
          bottom: -0.5rem;
          color: #fff;
          font-size: 0.2rem;
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }
    }

    .tulist {
      // height: 100vh;
      width: 100%;
      overflow: hidden;
      position: absolute;
      padding: 0.08rem 0.16rem;
      column-count: 2; /* 设置列数 */
      column-gap: 0.08rem; /* 设置列间距 */
      li {
        margin-bottom: 0.08rem;
        position: relative;
        width: 100%;
        break-inside: avoid;
        overflow: hidden;
        .pdf-box {
          margin: 0.08rem;
          background: #f5f6fa;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.085rem 0;
        }
        .tu-img-boy {
          max-height: 3rem;
          overflow: hidden;
          .cover {
            width: 100%;
            max-height: 3rem;
            border-radius: 0.1rem 0.1rem 0rem 0rem;
            display: block;
            // object-fit: ;
            object-fit: cover;
          }
        }
        .video-btn {
          white-space: nowrap; /* 防止文字换行 */
          border-radius: 0.32rem;
          background: rgba(40, 109, 247, 0.9);
          position: absolute;
          bottom: 0.6rem;
          left: 50%;
          transform: translate(-50%, -10%);
          padding: 0.04rem 0.08rem;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFang SC;
          font-size: 0.11rem;
          font-style: normal;
          font-weight: 400;
          img {
            width: 0.12rem;
            display: block;
            margin-right: 0.04rem;
          }
        }
        .hot-img {
          width: 0.51rem;
          position: absolute;
          top: 0;
          left: 0;
        }
        .title {
          margin: 0.08rem 0.08rem;
          color: #555;
          font-family: PingFang SC;
          font-size: 0.14rem;
          font-style: normal;
          font-weight: 400;

          white-space: nowrap; /* 防止文字换行 */
          overflow: hidden; /* 隐藏超出部分 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
        }

        .time {
          margin-bottom: 0.08rem;
          margin-left: 0.08rem;
          color: #999;
          font-family: PingFang SC;
          font-size: 0.12rem;
          font-style: normal;
          font-weight: 400;
        }

        .stock {
          margin-left: 0.08rem;
          font-family: PingFang SC;
          font-size: 0.12rem;
          font-style: normal;
          font-weight: 400;
          color: #999;
        }
      }
    }
  }

  //切换视图 新样式
  .tpNewList {
    margin: 0.15rem 0.2rem 0.2rem 0;
    padding-left: 0.17rem;
    height: calc(100vh - 1.62rem);
    overflow-y: auto;

    li {
      padding-bottom: 0.22rem;
      position: relative;
      border-left: 1px dashed #c4c4c4;
      padding-left: 0.17rem;

      .circle1,
      .circle2 {
        position: absolute;
        width: 0.09rem;
        height: 0.09rem;
        display: block;
        border-radius: 50%;
        left: -0.05rem;
        top: 0.05rem;
        background: #fff;
      }
      .circle1 {
        border: 0.03rem solid #c62329;
      }
      .circle2 {
        border: 0.03rem solid #c5c5c5;
      }
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-size: 0.14rem;
          .title {
            font-weight: 600;
            color: #1d2129;
          }
        }
        .right {
          color: #1d2129;
          font-size: 0.14rem;
        }
      }
      .correlation,
      .study {
        margin-top: 0.08rem;
      }
      .correlation {
        display: flex;
        align-items: center;
        .label {
          width: 0.65rem;
          color: #4e5969;
          font-size: 0.14rem;
        }
        .stokList {
          background: #f7f7fc;
          border-radius: 0.06rem;
          padding: 0.03rem 0.06rem;
          color: #222222;
          font-size: 0.12rem;
          display: flex;
          align-items: center;
          margin-right: 0.05rem;
          i {
            color: #ef3939;
            font-size: 0.1rem;
            border: 1px solid #ef3939;
            border-radius: 0.02rem;
            padding: 0 0.04rem;
            margin-right: 0.05rem;
          }
        }
      }

      .study {
        display: flex;
        align-items: center;
        .label {
          width: 0.65rem;
          color: #4e5969;
          font-size: 0.14rem;
        }
        .link {
          color: #286df7;
          font-size: 0.14rem;
          margin-right: 0.1rem;
        }
      }
      .cover {
        width: 100%;
        height: 1.16rem;
        border-radius: 6px;
        overflow: hidden;
        margin-top: 0.14rem;
      }
    }
  }

  // 黑色
  .blackTheme {
    .select_pop_bg {
      .select_pop {
        background: #171922;
      }
    }
    .search {
      background: #252732;
      input {
        background: #252732;
        color: #e4e9fe;
        &::placeholder {
          color: #6b7687;
        }
      }
    }
    .jytp-con {
      .sortTitle {
        color: #fff;
      }
      .tu-item-show {
        .title {
          color: #e4e9fe;
        }
        .time {
          color: #6b7687;
        }

        .stock {
          margin-left: 0.08rem;
          font-family: PingFang SC;
          font-size: 0.12rem;
          font-style: normal;
          font-weight: 400;
          color: #999;
        }

        .pdf-btn {
          margin: 0.08rem;
          background: #323545;
          color: #e4e9fe;
        }
      }

      .tulist {
        position: absolute;
        overflow: scroll;

        li {
          background: #272935;
          .pdf-box {
            margin: 0.08rem;
            background: #323545;
            color: #e4e9fe;
          }
          .tu-img-boy {
            max-height: 3rem;
            overflow: hidden;
          }
          .title {
            color: #e4e9fe;
          }

          .time {
            color: #6b7687;
          }
        }
      }
    }
    .classSelect {
      padding: 5px 0;
      .transversely {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.12rem;
        .moreBtn {
          color: #aab9d1;
          display: flex;
          align-items: center;
        }
      }
      .classifyList {
        display: flex;
        flex-wrap: wrap;
        color: #aab9d1;
        padding: 0.12rem 0.16rem;
        .item {
          border: 1px solid #31343e;
          text-align: center;
          padding: 0.08rem 0.17rem;
          border-radius: 0.06rem;
          margin-right: 0.1rem;
          margin-bottom: 0.1rem;
          font-size: 0.12rem;
          img {
            width: 0.1rem;
            height: 0.13rem;
          }
        }
        .classBtn {
          margin-top: 0.16rem;
          color: #fff;
          width: 100%;
          display: flex;
          .reset {
            text-align: center;
            width: 34%;
            color: #fff;
            border-radius: 0.32rem;
            background: #2f3239;
            margin-right: 0.1rem;
            padding: 0.11rem 0.41rem;
          }
          .confirm {
            text-align: center;
            width: 65%;
            border-radius: 0.32rem;
            background: #3b85fe;
            padding: 0.11rem 0.41rem;
          }
        }
      }
    }

    .tpNewList {
      li {
        border-left: 1px dashed #8c96a7;
        .circle2 {
          border: 0.03rem solid #4e5969;
          background: #12131a;
        }
        .top {
          .left {
            .title {
              color: #e4e9fe;
            }
          }
          .right {
            color: #e4e9fe;
          }
        }
        .correlation {
          .label {
            color: #6b7687;
          }
          .stokList {
            background: #272935;
            color: #e4e9fe;
          }
        }
      }
    }
  }
</style>
